export const INSTRUMENTS_OPTIONS = [
  'Basic',
  'Burn',
  'Basic Urology',
  'Craniotomy',
  'Special Plastic',
  'Ortho Basic',
  'GYN',
  'Midface',
  'Basic General',
  'Spine',
  'Cardiac',
  'Mandible',
  'Laparotomy',
  'Ortho Fx',
  'ENT',
  'Bookwalter',
]

export type TInstrumentsProps = {
  selectedInstruments: string[]
  onChange: (selectedOptions: string[]) => void
}
